import { useStaticQuery, graphql } from 'gatsby'

export const useHeaderQuery = () => {
  const { wp, mainMenuDropdownImages, mainMenu, topBarMenu } = useStaticQuery(graphql`
    query HeaderQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            logo {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: [WEBP], sizes: "(min-width: 1024px) 18vw, 47vw")
                }
              }
            }
            logoAltText
            phoneNumber
            header {
              estimateText
              emergencyText
              mobileCallIcon {
                localFile {
                  publicURL
                }
              }
              desktopCallIcon {
                localFile {
                  publicURL
                }
              }
              callText
              megaMenuButtonText
              residentialLink {
                icon {
                  localFile {
                    publicURL
                  }
                }
                text
                textMobile
                link {
                  url
                }
              }
              commercialLink {
                icon {
                  localFile {
                    publicURL
                  }
                }
                text
                textMobile
                link {
                  url
                }
              }
              requestButton {
                icon {
                  localFile {
                    publicURL
                  }
                }
                text
                arrow {
                  localFile {
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
      mainMenuDropdownImages: wpMenu(locations: { eq: PRIMARY_MENU }) {
        mainMenuImages {
          imageContainer {
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: [WEBP], sizes: "32vw")
                }
              }
            }
            altText
            whichMenuItemIsThisAssociatedWith
          }
        }
      }
      mainMenu: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: PRIMARY_MENU } }
      ) {
        nodes {
          label
          path
          childItems {
            nodes {
              label
              path
              childItems {
                nodes {
                  label
                  path
                }
              }
            }
          }
        }
      }
      topBarMenu: allWpMenuItem(
        filter: { parentDatabaseId: { eq: 0 }, locations: { eq: TOP_BAR_MENU } }
      ) {
        nodes {
          label
          path
        }
      }
    }
  `)
  return {
    wp,
    mainMenuDropdownImages,
    mainMenu,
    topBarMenu,
  }
}
